<template>
    <div>
        <NavTop/>
        <NavDark/>

        <div class="gray py-3">
            <div class="container">
                <div class="row">
                    <div class="colxl-12 col-lg-12 col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to="#">Home</router-link></li>
                                <li class="breadcrumb-item"><router-link to="#">Page</router-link></li>
                                <li class="breadcrumb-item active" aria-current="page">Error Page</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <section class="middle">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 col-xl-5 text-center">
                        <div class="p-4 d-inline-flex align-items-center justify-content-center circle bg-light-danger text-danger mx-auto mb-4"><i class="ti-face-smile fs-lg"></i></div>
                        <h2 class="mb-2 ft-bold">404. Page not found.</h2>
                        <p class="ft-regular fs-md mb-5">Sorry, we couldn't find the page you where looking for. We suggest that you return to home page.</p>
                        <router-link class="btn btn-dark" to="/">Go To Home Page</router-link>
                    </div>
                </div>
            </div>
        </section>

        <FooterTopTwo/>
        <FooterDark/>
        <ScrollToTop/>
    </div>
</template>

<script setup>
    import FooterDark from '@/components/footer/footer-dark.vue';
    import FooterTopTwo from '@/components/footer/footer-top-two.vue';
    import NavDark from '@/components/navbar/nav-dark.vue';
    import NavTop from '@/components/navbar/nav-top.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
</script>
